<template>
  <div>
    <Spinner
      v-if="isLoadingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.FETCHING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isSendingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.CREATING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isDeletingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.DELETING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isEditingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.EDITING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isSnoozingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.SNOOZING_ALERT"
    >
    </Spinner>
    <Spinner
      v-if="isUnSnoozingData"
      :fullscreen="true"
      :type="SPINNER_TYPE.UN_SNOOZING_ALERT"
    >
    </Spinner>

    <NormalHeaderLayout
      header="Suspicious traffic alerts"
      :isWithoutBackground="true"
    >
      <InfoBanner
        v-if="isShowSuccessInfoBanner"
        infoType="success"
        :infoText="successInfoBannerText"
        :displayDuration="2000"
        @onClose="handleSuccessInfoBannerClose"
      ></InfoBanner>
      <InfoBanner
        v-if="isShowErrorInfoBanner"
        infoType="danger"
        :infoText="errorInfoBannerText"
        :displayDuration="4000"
        @onClose="handleErrorInfoBannerClose"
      ></InfoBanner>

      <template v-if="isUserWithoutMemberAccount">
        <NoAccountLinked></NoAccountLinked>
      </template>
      <template
        v-else-if="
          isUserWithoutASN ||
            (isAlertListByASNFetched && !alertListOfSelectedASN.length)
        "
      >
        <WithoutAlertRule
          @showCreateAlertModal="showCreateAlertModal"
        ></WithoutAlertRule>
      </template>
      <template
        v-else-if="isAlertListByASNFetched && alertListOfSelectedASN.length"
      >
        <Overview></Overview>
      </template>

      <CreateAlertRuleModal
        v-if="isShowCreateAlertModal"
        :isEditing="isEditingAlert"
        @closeModal="closeCreateAlertModal"
        @submitAlert="submitAlert"
      ></CreateAlertRuleModal>

      <SnoozeAlertModal
        v-if="isShowSnoozeAlertModal"
        @onSetSnooze="setSnoozeAlert"
        @onCloseModal="closeSnoozeAlertModal"
      ></SnoozeAlertModal>

      <DeleteAlertModal
        v-if="isShowDeleteAlertModal"
        @onDeleteAlert="setDeleteAlert"
        @onCloseModal="closeDeleteAlertModal"
      >
      </DeleteAlertModal>

      <AlertActiveNoticeModal v-if="isShowAlertActiveNoticeModal">
      </AlertActiveNoticeModal>

      <TriggerHistory
        v-if="isShowTriggerOfSelectedAlertDetailsModal"
        @closeModal="closePrefixHistoryModal"
      ></TriggerHistory>
    </NormalHeaderLayout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';
import WithoutAlertRule from '../components/alerts/WithoutAlertRule.vue';
import Overview from '../components/alerts/overview/Overview.vue';
import CreateAlertRuleModal from '../components/alerts/createAlertRule/CreateAlertRuleModal.vue';
import TriggerHistory from '../components/alerts/overview/TriggerHistory.vue';
import Spinner from '../components/ui/Spinner.vue';
import InfoBanner from '../components/ui/InfoBanner.vue';
import SnoozeAlertModal from '../components/alerts/createAlertRule/SnoozeAlertModal.vue';
import DeleteAlertModal from '../components/alerts/createAlertRule/DeleteAlertModal.vue';
import AlertActiveNoticeModal from '../components/alerts/createAlertRule/AlertActiveNoticeModal.vue';
import NoAccountLinked from '../components/ui/NoAccountLinked.vue';
import { SPINNER_TYPE } from '../constants/common';

export default {
  name: 'AlertsSuspiciousTraffic',
  components: {
    NormalHeaderLayout,
    WithoutAlertRule,
    CreateAlertRuleModal,
    TriggerHistory,
    Overview,
    Spinner,
    InfoBanner,
    SnoozeAlertModal,
    DeleteAlertModal,
    AlertActiveNoticeModal,
    NoAccountLinked
  },

  data() {
    return {
      SPINNER_TYPE: SPINNER_TYPE
    };
  },

  computed: {
    ...mapState(['isSuccessfulSummaryRequest']),
    ...mapState('dataStore', ['selectedASN']),
    ...mapState('alertsSuspiciousTrafficStore', [
      'isLoadingData',
      'isSendingData',
      'isDeletingData',
      'isEditingData',
      'isSnoozingData',
      'isUnSnoozingData',
      'isShowCreateAlertModal',
      'isEditingAlert',
      'isShowSnoozeAlertModal',
      'isShowDeleteAlertModal',
      'isShowSuccessInfoBanner',
      'isShowErrorInfoBanner',
      'errorInfoBannerText',
      'isShowTriggerOfSelectedAlertDetailsModal',
      'infoBannerTop',
      'isShowAlertActiveNoticeModal',
      'successInfoBannerText',
      'isAlertListByASNFetched'
    ]),
    ...mapGetters('dataStore', ['noAccount', 'noASN']),
    ...mapGetters('alertsSuspiciousTrafficStore', ['alertListOfSelectedASN']),

    bannerTop() {
      return this.infoBannerTop + 'px';
    },
    isUserWithoutMemberAccount() {
      return this.isSuccessfulSummaryRequest && this.noAccount;
    },
    isUserWithoutASN() {
      return this.isSuccessfulSummaryRequest && !this.noAccount && this.noASN;
    }
  },
  methods: {
    ...mapActions('alertsSuspiciousTrafficStore', [
      'createAlert',
      'updateAlert',
      'snoozeAlert',
      'deleteAlert',
      'fetchAverageHit'
    ]),
    ...mapMutations('alertsSuspiciousTrafficStore', [
      'setIsShowCreateAlertModal',
      'setIsShowSnoozeAlertModal',
      'setIsShowDeleteAlertModal',
      'setIsShowTriggerOfSelectedAlertDetailsModal',
      'setIsShowSuccessInfoBanner',
      'setIsShowErrorInfoBanner',
      'setIsEditingAlert',
      'setEditingAlertObj'
    ]),
    ...mapActions('dataStore', ['selectASN']),
    showCreateAlertModal() {
      this.fetchAverageHit();
      this.setIsShowCreateAlertModal(true);
    },
    closeCreateAlertModal() {
      this.setIsShowCreateAlertModal(false);
      this.setEditingAlertObj({});
      this.setIsEditingAlert(false);
    },
    closeSnoozeAlertModal() {
      this.setIsShowSnoozeAlertModal(false);
    },
    closeDeleteAlertModal() {
      this.setIsShowDeleteAlertModal(false);
    },
    submitAlert(val) {
      if (this.isEditingAlert) {
        this.updateAlert(val);
      } else {
        this.createAlert(val);
      }
      this.closeCreateAlertModal();
    },
    setSnoozeAlert(val) {
      this.snoozeAlert(val);
      this.closeSnoozeAlertModal();
    },
    setDeleteAlert(val) {
      this.deleteAlert(val);
      this.closeDeleteAlertModal();
    },
    closePrefixHistoryModal() {
      this.setIsShowTriggerOfSelectedAlertDetailsModal(false);
    },
    handleSuccessInfoBannerClose() {
      this.setIsShowSuccessInfoBanner(false);
    },
    handleErrorInfoBannerClose() {
      this.setIsShowErrorInfoBanner(false);
    }
  },
  mounted() {
    const asnId = this.selectedASN && this.selectedASN.id;
    asnId && this.selectASN(asnId);
  }
};
</script>

<style lang="scss" scoped></style>
